import React from "react";
import { Card, Button, Switch, Popconfirm, Space } from "antd";
import { LogoutOutlined, PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";

interface ControlsCardProps {
  isConnected: boolean;
  botEnabled: boolean;
  isLoggingOut: boolean;
  isToggling: boolean;
  onLogout: () => void;
  onToggle: (enabled: boolean) => void;
}

export const ControlsCard = ({
  isConnected,
  botEnabled,
  isLoggingOut,
  isToggling,
  onLogout,
  onToggle,
}: ControlsCardProps) => {
  return (
    <Card
      title="Bot Controls"
      bordered={false}
      className="bg-white rounded-lg border border-gray-200"
    >
      <Space direction="vertical" className="w-full" size="large">
        {/* Enable / Disable Toggle */}
        <div className="flex items-center justify-between py-2 border-b border-gray-100">
          <div>
            <p className="text-sm font-semibold text-gray-700 m-0">
              {botEnabled ? (
                <span className="flex items-center gap-1">
                  <PlayCircleOutlined className="text-green-500" /> Bot Active
                </span>
              ) : (
                <span className="flex items-center gap-1">
                  <PauseCircleOutlined className="text-orange-400" /> Bot Paused
                </span>
              )}
            </p>
            <p className="text-xs text-gray-400 m-0 mt-1">
              {botEnabled
                ? "The bot is currently responding to customer messages."
                : "The bot will receive messages but will not reply until re-enabled."}
            </p>
          </div>
          <Switch
            checked={botEnabled}
            loading={isToggling}
            disabled={!isConnected}
            onChange={onToggle}
            checkedChildren="ON"
            unCheckedChildren="OFF"
          />
        </div>
      </Space>
    </Card>
  );
};
